import React from "react";
import "./style.scss";
import { MetadataDetails } from "./types";
import { getLastUpdatedDateFormat } from "../../../utils";

const DocumentMetadata: React.FC<MetadataDetails> = ({
  idPostfix,
  companyName,
  activeIngredient,
  smpclastUpdated,
  pricelastUpdated,
  legalCategory,
  reference,
}: MetadataDetails) => {
  return (
    <div className="metadataGroup">
      <div className="metadataRow">
        <div className="metadataCell">
          <div className="title">{companyName}</div>
          <div className="value">
            <span className="contact-details-link">
              <a href={"#contact_details" + idPostfix}>Contact Details</a>
            </span>
          </div>
        </div>
      </div>
      <div className="metadataRow">
        <div className="metadataCell">
          <div className="last-updated">
            <div className="app-subtitle">
              <strong>Last Updated</strong>
            </div>
            <div className="datesContainer">
              <div className="date">
                <span>SmPC:{"\u00a0"}</span>
                <span> {getLastUpdatedDateFormat(smpclastUpdated)}</span>
              </div>
              <div className="date">
                <span>Price:{"\u00a0"}</span>
                <span>{getLastUpdatedDateFormat(pricelastUpdated)}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="metadataCell">
          <a href={"#PRICE" + idPostfix}>Price</a>
        </div>
      </div>

      <div className="metadataRow">
        <div className="metadataCell">
          <div className="title">Active Ingredient</div>
          <ul className="value item-list">
            {activeIngredient &&
              activeIngredient.map((ingredient, index) => {
                return <li key={index}>{ingredient}</li>;
              })}
          </ul>
        </div>
        <div className="metadataCell">
          <div className="title">Legal Category</div>
          <ul className="item-list">
            {legalCategory &&
              legalCategory.map((category, index) => {
                return <li key={index}>{category}</li>;
              })}
          </ul>
        </div>
      </div>
      {reference && (
        <div className="metadataRow">
          <div className="reference">
            <div className="app-subtitle">Reference</div>
            <div>{reference}</div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DocumentMetadata;
